import { render, staticRenderFns } from "./reward_record_detail.vue?vue&type=template&id=39c096e7&scoped=true"
import script from "./reward_record_detail.vue?vue&type=script&lang=js"
export * from "./reward_record_detail.vue?vue&type=script&lang=js"
import style0 from "./reward_record_detail.vue?vue&type=style&index=0&id=39c096e7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c096e7",
  null
  
)

export default component.exports